module.exports = __webpack_public_path__ + "img/person.476cab68.svg";